<script>
import BaseView from '../base/base-view'
import getViewConfig from './guide-view-config'

export default {
    name: 'GuideView',
    // -------------------------------- Extends -------------------------------------
    extends: BaseView,

    // -------------------------------- Props ---------------------------------------
    props:{
        highlightedUnits:{type: Array, default:() => []},
        highlightColor:{type: String, default: "#E25046" },    },
    // -------------------------------- Computed ------------------------------------
    computed:{
        guideViewConfig() {
            return getViewConfig(this.expandedLevels)
        }
    },

    methods:{
        beforeGoToView(){
            this.highlightUnits()
            this.highlightGuideStep(-1)
        },
        highlightGuideStep(stepIndex){
            this.mapViewer.viewApi.set_selected_step(stepIndex)
        },
        highlightUnits(){
            if(this.isActive){
                this.mapViewer.viewApi.restore_base_color()
                const that = this
                this.highlightedUnits.forEach(u => {
                    that.mapViewer.viewApi.set_base_hex_color(u, that.highlightColor)
                } )
            }
            else
                this.mapViewer.viewApi.restore_base_color()
        }
    },
    watch:{
        /* isActive:{
            handler: "highlightUnits",
            immediate: true,
        }*/
    },

    created(){
        //Each child view should call this method to include their view config prop name to inheritance collection
        this.addInheritedView('guideViewConfig')
    },
    beforeDestroy() {
        this.mapViewer.viewApi.restore_base_color()
    }
}
</script>
